import type { RelationOption } from '@/modules/zy-crm/utils/relation-options';
import { getSessionSnapshot } from '@/state/sessionSnapshot';

export const getCurrentUser = (): API.CurrentUser | null => {
  return (getSessionSnapshot().currentUser as API.CurrentUser | null) ?? null;
};

export const getCurrentMemberUuid = (): string | null => {
  return getCurrentUser()?.memberUuid ?? null;
};

export const getCurrentMemberOption = (): RelationOption | null => {
  const currentUser = getCurrentUser();
  const value = String(currentUser?.memberUuid || '').trim();
  if (!value) return null;
  const label = String(
    currentUser?.name ||
      currentUser?.nickname ||
      currentUser?.username ||
      currentUser?.phone ||
      value,
  ).trim();
  return {
    value,
    label: label || value,
  };
};

export const requireCurrentMemberUuid = (): string => {
  const memberUuid = getCurrentMemberUuid();

  if (!memberUuid) {
    throw new Error('当前会话缺少 memberUuid，请先完成登录并刷新当前用户信息');
  }

  return memberUuid;
};

export const hasCurrentMemberUuid = (): boolean => {
  return Boolean(getCurrentMemberUuid());
};
